<template>
  <div class="login">
      <div class="from">
           <h2 class="titles"><img src="../assets/logo.png" alt="" style="height: 55px;margin-bottom: -10px;"> 升维服务平台</h2>
          <div class="fromcontent">
            <p>账号密码登录</p>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0" class="demo-ruleForm">
                <el-form-item label="" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="账号" prefix-icon="el-icon-user"></el-input>
                </el-form-item>
                <el-form-item label="" prop="pwd">
                    <el-input v-model="ruleForm.pwd" type="password" placeholder="密码" prefix-icon="el-icon-unlock"></el-input>
                </el-form-item>
                <!-- <el-checkbox v-model="checked" style="text-align: right;width: 100%;">自动登录</el-checkbox> -->
                <el-form-item>
                    <el-button  v-preventReClick type="primary" @click="submitForm('ruleForm')" style="width: 100%;margin-top: 31px;">立即登录</el-button>
                </el-form-item>
            </el-form>
          </div>
      </div>
      <p class="beian" @click="beiannum()">备案号：冀ICP备2020024009号-1</p>
  </div>
</template>

<script>
import {selectUser} from '../axios/api'
export default {
    data(){
        return{
            ruleForm: {
                name: '',
                pwd:''
            },
            rules: {
                name: [
                    { required: true, message: '请输入账号', trigger: 'blur' },
                ],
                pwd: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                ],
            },
            checked:true
        }
    },
    methods:{
        submitForm(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                  var {data:dt} = await selectUser({
                      loginNumber:this.ruleForm.name ,
                      password:this.ruleForm.pwd,

                  })  
                  console.log(dt)
                  if(dt.code == 200){
                       this.$message.success('登录成功')
                       window.localStorage.setItem('name',dt.data.shopAdmin.shopName)
                       window.localStorage.setItem('loginNumber',dt.data.shopAdmin.loginNumber)
                       window.localStorage.setItem('token',dt.data.token)
                       window.localStorage.setItem('shopId',dt.data.shopAdmin.id)
                       window.localStorage.setItem('state',1)
                      this.$router.push('/home')
                  }else{
                      this.$message.error(dt.message)
                  }
                }
            });
        },
        beiannum(){
            window.open('https://beian.miit.gov.cn/', '_blank');
        }
    }
}

</script>
<style lang="less" scoped>
.login{
    height: 100%;
    width: 100%;
    // background: rgba(241, 242, 246, 1);
    background: url(../assets/timg.jpeg) no-repeat;
    background-size: 100% 100%;
    .from{
        width: 100%;
        border-radius: 5px;
        padding: 20px;
        box-sizing: border-box;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        .titles{
            text-align: center;
            color: #2f5e92;
            font-size: 60px;
            font-weight: 500;
            margin-bottom: 30px;

        }
        .fromcontent{
            width: 20%;
            background: #fff;
            border-radius: 5px;
            height: 350px;
            padding: 20px;
            box-sizing: border-box;
            margin: 0 auto;
            // position: absolute;
            // top: 55%;
            // left: 50%;
            // transform: translate(-50%, -50%);
            // text-align: center;
        }
        p{
            height: 50px;
            line-height: 40px;
            font-size: 20px;
            font-weight: 700;
            margin-bottom: 15px;
        }
       .el-form-item{
            margin-bottom: 35px;
            .el-input__icon{
                font-size: 18px!important;
            }
        }
        
    }
    .beian{
        position: fixed;
        width: 100%;
        text-align: center;
        color: #fff;
        bottom: 30px;
        cursor: pointer;
    }
}
</style>